import React from 'react';
import ActionButton from '../../common/ActionButton';

interface TimesheetNavigationProps {
    currentIndex: number;
    totalGroups: number;
    onPrevious: () => void;
    onNext: () => void;
}

export const TimesheetNavigation: React.FC<TimesheetNavigationProps> = React.memo(({
    currentIndex,
    totalGroups,
    onPrevious,
    onNext,
}) => (
        <div className="timesheet-modal-navigation">
            <ActionButton
                iconClass="icon-arrow-left-12"
                onAction={onPrevious}
                className="timesheet-nav-button"
                disabled={currentIndex === 0}
                compact={true}
            />
            <span className="nav-status timesheet-nav-status">
                View {currentIndex + 1} of {totalGroups}
            </span>
            <ActionButton
                iconClass="icon-arrow-right-12"
                onAction={onNext}
                className="timesheet-nav-button"
                disabled={currentIndex === totalGroups - 1}
                compact={true}
            />
        </div>
    ));

TimesheetNavigation.displayName = 'TimesheetNavigation';

